'use client';

import { useBoolean } from '@/hooks';

type UseCopyToClipboardOptions = {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
  timeout?: number;
};

function useCopyToClipboard({
  timeout = 2000,
  onSuccess,
  onError,
}: UseCopyToClipboardOptions = {}) {
  const { onTrue, onFalse, value: isCopied } = useBoolean(false);

  const copy = async (text: string) => {
    if (typeof navigator?.clipboard?.writeText !== 'function') {
      const error = new Error('Clipboard API not available');
      if (onError) {
        onError(error);
      }
      return;
    }

    try {
      await navigator.clipboard.writeText(text);
      onTrue();

      if (onSuccess) {
        onSuccess();
      }
      setTimeout(onFalse, timeout);
    } catch (error) {
      if (onError) {
        onError(error as Error);
      }
    }
  };

  return { isCopied, copy };
}

export default useCopyToClipboard;
